import React from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'

const TermsConditions = () => {
  window.scrollTo(0, 0);
  return (
    <>
      <Header />
      <div className='bgtheme py-4 h4 text-white text-center'>Terms & Conditions</div>

      <div className="container my-5">
        <p><strong>Last updated:</strong> October 2025</p>
        <p>
          Welcome to Vasta. These Terms and Conditions ("Terms") govern your use of the Vasta mobile
          application and website (collectively, the "Platform"), operated by Vasta Technologies FZ-LLC,
          registered in the Ajman Free Zone, United Arab Emirates ("Vasta," "we," "our," or "us").
        </p>
        <p>
          By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree,
          please do not use Vasta.
        </p>

        <h4 className='mt-5'>1. About Vasta</h4>
        <p>
          Vasta is a discovery and booking platform that allows users to find and book appointments
          with local businesses across various categories such as salons, spas, automotive services,
          dining, and more. Vasta does not provide these services directly, as all services are offered
          by independent third-party businesses ("Vendors").
        </p>

        <h4 className='mt-5'>2. Eligibility</h4>
        <p>
          You must be at least 18 years old to use the Platform. By using Vasta, you confirm that all
          information you provide is true, accurate, and complete.
        </p>

        <h4 className='mt-5'>3. Use of the Platform</h4>
        <ul>
          <li>You agree to use Vasta only for lawful purposes.</li>
          <li>You may not attempt to interfere with the operation or security of the Platform.</li>
          <li>You may not use any automated tools or bots to access or collect data from Vasta.</li>
        </ul>

        <h4 className='mt-5'>4. Relationship with Vendors</h4>
        <p>
          Vasta acts solely as an intermediary between users and vendors. When you make a booking,
          you enter into a direct relationship with the vendor. Vasta is not responsible for the quality,
          safety, suitability, or availability of any service provided by a vendor.
        </p>

        <h4 className='mt-5'>5. No Payments</h4>
        <p>
          Currently, all payments (if any) are made directly to the vendor at the time of service. Vasta
          does not process or handle any payments on behalf of vendors or users.
        </p>

        <h4 className='mt-5'>6. Account Information</h4>
        <p>
          You are responsible for maintaining the confidentiality of your login details and for all
          activity under your account. Notify us immediately if you suspect unauthorized access to
          your account.
        </p>

        <h4 className='mt-5'>7. Marketing Communication</h4>
        <p>
          By opting in during sign-up, you agree to receive promotional offers, updates, and discounts
          via email, SMS, or push notifications. You may opt out at any time through your account
          settings or by contacting us.
        </p>

        <h4 className='mt-5'>8. Intellectual Property</h4>
        <p>
          All content on the Platform, including logos, design, text, graphics, and software, is owned
          or licensed by Vasta. You may not reproduce, modify, or distribute any part of it without our
          written consent.
        </p>

        <h4 className='mt-5'>9. Limitation of Liability</h4>
        <p>
          Vasta is not liable for any damages or losses arising from:
        </p>
        <ul>
          <li>The use or inability to use the Platform,</li>
          <li>Any service provided by a vendor,</li>
          <li>Or any unauthorized access to your data.</li>
        </ul>
        <p>Your use of the Platform is at your own risk.</p>

        <h4 className='mt-5'>10. Changes to These Terms</h4>
        <p>
          We may update these Terms from time to time. Any changes will be posted on our website or
          app with the updated date. Continued use after updates means you accept the revised Terms.
        </p>

        <h4 className='mt-5'>11. Contact</h4>
        <p>
          For any questions, please contact us at: <a href="mailto:adnan@vasta.ae">adnan@vasta.ae</a> or <a href="mailto:joshua@vasta.ae">joshua@vasta.ae</a>
        </p>
      </div>

      <Footer />
    </>
  )
}

export default TermsConditions
